export enum MEDIAS {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=6975636
     */
    ADD_FILES = 'FRONT.ATTACHMENTS.ADD_FILES',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=6975637
     */
    ADD_IMAGES = 'FRONT.ATTACHMENTS.ADD_MEDIA',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=787127867
     */
    CONFIRM_DELETE_MEDIA_TITLE = 'MEDIAS.CONFIRM_DELETE_MEDIA_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=787127905
     */
    CONFIRM_DELETE_MEDIA_MESSAGE = 'MEDIAS.CONFIRM_DELETE_MEDIA_MESSAGE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=787127949
     */
    CONFIRM_EMPTY_TRASH_TITLE = 'MEDIAS.CONFIRM_EMPTY_TRASH_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=787131924
     */
    CONFIRM_EMPTY_TRASH_MESSAGE = 'MEDIAS.CONFIRM_EMPTY_TRASH_MESSAGE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=787132430
     */
    CONFIRM_RESTORE_MEDIA_TITLE = 'MEDIAS.CONFIRM_RESTORE_MEDIA_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=787135193
     */
    CONFIRM_RESTORE_MEDIA_MESSAGE = 'MEDIAS.CONFIRM_RESTORE_MEDIA_MESSAGE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=706412592
     */
    EMPTY_FOLDER = 'MEDIAS.EMPTY_FOLDER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=7274264
     */
    EMPTY_TRASH = 'FRONT.MEDIA_PICKER.HEADER_EMPTY_TRASH',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=15076956
     */
    FILE_DELETED = 'FRONT.DOCUMENT.DELETE.FILE.SUCCESS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=700077166
     */
    FILE_MOVED = 'MEDIAS.FILE_MOVED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=700746593
     */
    FOLDER_MOVED = 'MEDIAS.FOLDER_MOVED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=148984636
     */
    FROM_GOOGLE_DRIVE = 'MEDIAS.PICK_FILE_FROM_GOOGLE_DRIVE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=49149927
     */
    FROM_MEDIA_LIBRARY = 'FRONT.POST_DIALOG.ADD_ATTACHMENTS.FROM_MEDIA_LIBRARY',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=148994040
     */
    FROM_MICROSOFT_SHAREPOINT = 'MEDIAS.PICK_FILE_FROM_MICROSOFT_SHAREPOINT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=458347178
     */
    MAX_FILES = 'MEDIAS.MAX_FILES',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=7667065
     */
    MEDIA_LIBRARY = 'ADMIN.NAV.MEDIA_LIBRARY',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=12756245
     */
    MEDIA_TRASH = 'ADMIN.NAV.MEDIA_TRASH',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=7244379
     */
    NAV_MEDIA = 'ADMIN.NAV.MEDIA',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=421915470
     */
    NEXT_IMAGE = 'MEDIAS.NEXT_IMAGE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=701367412
     */
    NO_MEDIA_YET = 'MEDIAS.NO_MEDIA_YET',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=721946646
     */
    OPEN_FOLDER = 'MEDIAS.OPEN_FOLDER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=421915543
     */
    PREVIOUS_IMAGE = 'MEDIAS.PREVIOUS_IMAGE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=423304601
     */
    REMOVE_IMAGE = 'MEDIAS.REMOVE_IMAGE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=574419262
     */
    SELECT_FOLDERS = 'MEDIAS.SELECT_FOLDERS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=574064685
     */
    SELECTED_FOLDERS_COUNT = 'MEDIAS.SELECTED_FOLDERS_COUNT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=707668233
     */
    DOWNLOAD_FILE_NAME_WITH_SIZE = 'GLOBAL.DOWNLOAD_FILE_NAME_WITH_SIZE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=707699245
     */
    FILE_SIZE_B = 'GLOBAL.FILE_SIZE_B',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=707685984
     */
    FILE_SIZE_KB = 'GLOBAL.FILE_SIZE_KB',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=707698875
     */
    FILE_SIZE_MB = 'GLOBAL.FILE_SIZE_MB',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=707705933
     */
    FILE_SIZE_GB = 'GLOBAL.FILE_SIZE_GB',
}
